import { useState } from 'react';
import { getSetting, setSetting, settingKeys } from '../utils/settings';

const key = settingKeys.chordBarsSongRhythms;

/**
 * The rhythm picked in the player for one song on this device, or null where none has been. It
 * plays over every part of the song, overrides included. Setting null forgets it.
 */
const useSongRhythm = (songId) => {
  const [choice, setChoice] = useState(() => (songId && getSetting(key)?.[songId]) || null);

  const update = (next) => {
    setChoice(next);

    if (!songId) return;

    const picks = { ...getSetting(key) };

    if (next) picks[songId] = next;
    else delete picks[songId];

    setSetting(key, picks);
  };

  return [choice, update];
};

export default useSongRhythm;
